import axios from "axios";
import http from "../http-common";

// where the backend is running+/api+/auth/
const API_URL = "https://jueces-be.ligacantabria.com/api/auth/";
//const API_URL = "http://localhost:8080/api/auth/";

const register = (primernombre, segundonombre, primerapellido, segundoapellido, fechadenacimiento, 
  curp, telefonomovil, arean1, arean2, imageprofile, bio, genero,email, password, confirmpassword, roles, banco, clabe) => {
  
    return axios.post(API_URL + "signup", {
    primernombre, segundonombre, primerapellido, segundoapellido, 
    fechadenacimiento, curp, telefonomovil, 
    arean1, arean2, imageprofile, bio, genero, email, password, confirmpassword, roles, banco, clabe
  });
};

const login = (email, password) => {
  
  {/** for testing purposes only
  
  const user = {id:1, username: "username", roles: "admin", accessToken: "yes"};
  
  const response = {data: {
    id: user.id,
    username: user.username,
    email: user.email,
    roles: user.roles,
    accessToken: user.accessToken
  }};

  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }

  return response.data;
  */}

  return axios
    .post(API_URL + "signin", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
    {/**
    .catch(() => {
      console.log(response.data);
      localStorage.setItem("user", JSON.stringify(response.data));
      return response.data;
    }); */}
    

};

const logout = () => {
  localStorage.removeItem("user");
  console.log("log out done");
};

const changepsw = (id,currpassword,newpassword) => {
  return http //axios
    .put(API_URL + "changepsw", {
      id,
      currpassword,
      newpassword,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
}

const resetpsw = (requesteriduser, iduser,newpassword) => {
  return http
    .put(API_URL + "resetpsw", {
      requesteriduser,
      iduser,
      newpassword,
    })
    .then((response) => {
      //if (response.data.accessToken) {
      //  localStorage.setItem("user", JSON.stringify(response.data));
      //}

      return response.data;
    });
}

export default {
  register,
  login,
  logout,
  changepsw,
  resetpsw,
};